import React, { useRef, useState } from 'react';
import { ReadDataStorage, IDCOMPANY, TOKEN_KEY } from '../../../services/auth';

const SmsCampaignEmbed = () => {
  const iframeRef = useRef(null);
  const _token = ReadDataStorage(TOKEN_KEY);
  const [url] = useState(
    process.env.REACT_APP_NEW_LAYOUT +
      '/sms-campaign/' +
      ReadDataStorage(IDCOMPANY) +
      '/' +
      JSON.parse(_token).token
  );

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
        <iframe
          ref={iframeRef}
          src={url}
          title="Campanhas SMS"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          style={{ width: '100%', height: '100%', border: 0 }}
        />
      </div>
    </div>
  );
};

export default SmsCampaignEmbed;
